
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offers/special-offers/[[...page]]",
      function () {
        return require("private-next-pages/offers/special-offers/[[...page]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offers/special-offers/[[...page]]"])
      });
    }
  